<template>
    <div id="thermostat-widget" class="form-group">
        <div class="flex items-center"
             :id="fieldName + '-select-field'"
             :class="{ 'has-error': form.errors.has(this.fieldConfig.value_field) }">
            <div class="flex justify-between" style="width: 94%;">
                <label class="form-control-label"><span v-html="fieldConfig.label"></span>
                    <span class="required" v-if="fieldConfig.field_extra.required">&nbsp;&nbsp;(*)</span>
                    <span v-if="withHelpIcon" :class="fieldConfig.field_extra.withIcon" :title="fieldConfig.field_extra.helpText"></span>
                </label>
                <div>
                    <button style="padding: 10px;" @click="showModal = true"><span class="fa fa-edit"></span></button>
                </div>
            </div>
            <span class="help-block" v-if="form.errors.has(this.fieldConfig.value_field)">
                {{ form.errors.get(this.fieldConfig.value_field, true) }}
            </span>
            <div v-if="hasHelpText">
                <span v-html="fieldConfig.field_extra.helpText"></span>
            </div>
        </div>
        <div v-if="displays1" class="equipment-version-information" v-bind:style=" hasErrors ? 'border: 1px solid red;' : '' ">
            <div class="flex">
                <div class="w-half">
                    <div v-for="displayItem in displays1" class="flex align-items-center">
                        <label class="m-2">{{ displayItem.label }}:</label>
                        <span class="m-2">{{ form.data[displayItem.field] }}</span>
                    </div>
                </div>
                <div class="w-half">
                    <div v-for="displayItem in displays2" class="flex align-items-center">
                        <label class="m-2">{{ displayItem.label }}:</label>
                        <span class="m-2">{{ form.data[displayItem.field] }}</span>
                    </div>
                </div>
            </div>
        </div>
        <span class="errors" v-if="hasErrors">
            <ul style="list-style-type:none;">
              <li v-for="error in getErrors">
                {{ error }}
              </li>
            </ul>
        </span>
        <modal
            v-if="showModal"
            modalWidth="75%"
            @close="showModal = false"
        >
            <span slot="header">&nbsp;</span>

            <slot slot="body">
                <thermostat-adjustment-form :display-fields="getFilteredDisplayFields()" @close-modal="showModal=false"></thermostat-adjustment-form>
            </slot>
        </modal>
    </div>
</template>
<script>
    import { FormFieldMixin } from 'laravel-vue-forms';

    export default {

        mixins: [
            FormFieldMixin
        ],

        data() {
            return {
                showModal: false,
                thermostatAdjustmentFormConfiguration: null,
                thermostatAdjustmentData: null,
                systemTypeOptionName: null,
            }
        },
        created() {
            const systemTypeField = this.form.fields.find(field => field.value_field === this.fieldConfig.field_extra.controls_field);
            // System type options are not loaded when this component is first created.
            // This component waits for the options to become available, then uses their names
            // to filter out non-required sections and inputs.
            if (systemTypeField) {
                window.Bus.$on('options-loaded', this.fetchSystemTypeOptions);
            }
        },
        destroyed() {
            this?.unwatchSystemFieldOptionUpdate()
        },
        methods: {
            fetchSystemTypeOptions() {
                // The 'options-loaded' event is emitted before the property is actually updated,
                // so we wait until everything is settled before checking the name.
                this.$nextTick(() => {
                    const valueId = this.fieldConfig.field_extra.controls_field;
                    if (this.form.formFieldOptions[valueId]) {
                        window.Bus.$off('options-loaded', this.fetchSystemTypeOptions);
                        this.systemTypeOptionName = this.getNameOfFieldValue(valueId, this.form.data[valueId]);
                        this.unwatchSystemFieldOptionUpdate = this.$watch(
                            () => this.form.data[valueId],
                            (newValue) => {
                                this.systemTypeOptionName = this.getNameOfFieldValue(valueId, newValue);
                            }
                        );
                    }
                })
            },
            getNameOfFieldValue(fieldName, value) {
                const selected = this.form.formFieldOptions[fieldName]?.find(e => e.id === Number(value));
                return selected?.name;
            },
            getFilteredDisplayFields() {
                // Return empty array if displays are missing
                if (!this.fieldConfig?.field_extra?.displays) {
                    return [];
                }

                return this.fieldConfig.field_extra.displays
                    .filter(displayItem => {
                        // Determine if the field should be visible based on controls_field_if or systemTypeOptionName
                        const displayable = !displayItem.controls_field_if 
                            || displayItem.controls_field_if.includes(this.systemTypeOptionName);

                        // Update form data if null or empty
                        // Since systemTypeOptionName is reactive, we check if it is set first before updating the data
                        if(this.systemTypeOptionName) {
                            if(displayable) {
                                if (this.form.data[displayItem.field] === null || this.form.data[displayItem.field] === '') {
                                    this.form.data[displayItem.field] = 0;
                                }
                            } else {
                                this.form.data[displayItem.field] = null;
                            }
                        }

                        return displayable;
                });
            }
        },
        computed: {
            displays1() {
                const filteredFields = this.getFilteredDisplayFields();
                const halfLength = Math.ceil(filteredFields.length / 2);
                return filteredFields.slice(0, halfLength);
            },
            displays2() {
                const filteredFields = this.getFilteredDisplayFields();
                const halfLength = Math.ceil(filteredFields.length / 2);
                return filteredFields.slice(halfLength);
            },
            hasErrors() {
                return (
                    ('heating_set_back_degrees' in this.form.errors.fieldErrors) ||
                    ('cooling_set_back_degrees' in this.form.errors.fieldErrors) ||
                    ('set_back_hours' in this.form.errors.fieldErrors) ||
                    ('days_closed' in this.form.errors.fieldErrors) ||
                    ('floor_area' in this.form.errors.fieldErrors)
                )
            },
            getErrors() {
                let fields = ["heating_set_back_degrees",
                    "cooling_set_back_degrees",
                    "set_back_hours",
                    "days_closed",
                    'floor_area'
                ];

                //Get all form errors and return the messages for just this component
                let errors = Object.entries(this.form.errors.fieldErrors).map(([key, value]) => ({key,value}));
                return errors.filter(error=>fields.includes(error.key)).map(error=>error.value).flat();
            }
        },
    }
</script>
